var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h-statistics2',{ref:"statistics2",staticStyle:{"margin-bottom":"24px"},attrs:{"lastThreeDaysTopRight":_vm.lastThreeDaysTopRight}}),_c('h-statistics1',{ref:"statistics1",staticStyle:{"margin-bottom":"24px"}}),_c('h-statistics3',{ref:"statistics3"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }